; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('browserClass', ['browserDetect'], factory);
    } else {
        // Browser globals
        root.browserClass = factory(root.browserDetect);
    }
}(typeof self !== 'undefined' ? self : this, function (browserDetect) {
    'use strict';

    if (typeof browserDetect !== 'function') {
        throw new ReferenceError('browser-detect is required: https://www.npmjs.com/package/browser-detect');
    }

    function isIPhone() {
        return navigator.userAgent.toLowerCase().indexOf('iphone') > -1;
    }

    function setVariant(cl, components, body) {
        body.classList.add(cl);

        Array.prototype.forEach.apply(components, [function (el) {
            if (typeof el.classList !== 'undefined') {
                el.classList.add(cl);
            }
        }]);
    }

    return function (prefix) {
        'use strict';

        var result = browserDetect();

        var body = document.querySelector('body');

        if (!body) return;

        var components = typeof prefix === 'string'
            ? document.querySelectorAll('[class*="' + prefix + '"]')
            : [];

        if (typeof prefix === 'string' && prefix.length) {
            setVariant('-' + result.name, components, body);
            setVariant('-' + result.name + parseInt(result.versionNumber), components, body);
        }

        if (isIPhone()) {
            setVariant('-iphone', components, body);
        }

        return result;
    };
}));

